export class PagamentoPedido {
  id: number;
  pedidoId: number;
  valorCartao: number;
  valorDinheiro: number;
  valorTicket: number;
  valorFiado: number;
  valorPIX: number;
}
